import { render } from "./GuidePackages.vue?vue&type=template&id=6dbe4fb7"
import script from "./GuidePackages.vue?vue&type=script&lang=js"
export * from "./GuidePackages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator,QBanner,QMarkupTable,QIcon});
